import { Input, Output } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { RenderingContext, RenderingContextProvider } from './../../../api';
import {
  DEFAULT_LAYOUT_MODE,
  KEY_LAYOUT_MODE,
  opBoxLayoutMode,
  opDistinctUntilChanged,
  opShareLast,
  rxPipe,
} from './../../../utils';
import { li } from './../../services/logger/logger.service';
import { defineProperties, getClassName } from './../../utils/js.utils';
import { AbstractLifeCycleComponent, createSetter } from './abstract.lifecycle.component';

/* Copyright IBM Corp. 2017 */
const LOGGER = 'AbstractBaseComponent';

let ID = 0;

export abstract class AbstractBaseComponent extends AbstractLifeCycleComponent implements RenderingContextProvider {
  /*
     * The rendering context for the page. This is the context
     * of the element that is referenced by the currently active route.
     */
  @Output() onRenderingContext: Observable<RenderingContext>;

  /*
     * Fires whenever the layout mode changed, includes the initial default mode.
     */
  @Output() readonly onLayoutMode: Observable<string>;

  /*
     * Set the layout mode to render this page
     *
     * @param aValue the new layout mode, if nothing is given this defaults to 'default'
     */
  @Input() layoutMode: string;

  constructor() {
    // default
    super();
    // attach the handlers
    const that = this;
    // base name
    const componentId = `${getClassName(that, LOGGER)}[${ID++}]`;
    // the subjects
    const modeSubject = new BehaviorSubject<string>(DEFAULT_LAYOUT_MODE);
    // define the setters
    const onLayoutMode = rxPipe(
      modeSubject,
      opBoxLayoutMode,
      opDistinctUntilChanged,
      tap(() => li(LOGGER, 'onLayoutMode', componentId), undefined, () =>
        li(LOGGER, 'onLayoutModeComplete', componentId)
      ),
      opShareLast
    );
    // assign
    defineProperties(that, {
      [KEY_LAYOUT_MODE]: createSetter(modeSubject, that)
    });
    // attach the handler
    this.onLayoutMode = onLayoutMode;
  }
}
